export const useTopLevelLocale = () => {
  const { locale } = useI18n()
  const topLevelLocale = computed(() => getTopLevelLocale(locale.value))
  return { topLevelLocale }
}
